<template>
  <div class="about container" v-if="!loading">
    <div v-if="about">
      <h2 class="my-8 mx-5">{{ $ucfirst($t('screens.aboutScreen', { catalog: 'app_mobile'})) }}</h2>
    </div>
    <div class="row border standard-layout mx-0 mt-5 pa-5" v-if="about" style="flex-direction: column">
      <div v-for="part in about.parts" v-bind:key="part.id">
        <p v-html="part.text"></p>
      </div>
      <div class="mb-3">
        <v-btn text href="https://coroprevention.eu/" target="_blank">
          <v-icon class="mr-2">mdi-open-in-new</v-icon>
          {{ $ucfirst($t("about.projectWebsite", { catalog: "app_mobile" })) }}
        </v-btn>
      </div>
      <div class="mb-3">
        <v-btn
          text
          href="https://coroprevention.eu/privacy"
          target="_blank"
        >
          <v-icon class="mr-2">mdi-open-in-new</v-icon>
          {{ $ucfirst($t("about.privacyPolicy", { catalog: "app_mobile" })) }}
        </v-btn>
      </div>
      <div class="mb-3">
        <v-btn
          text
          href="https://coroprevention.eu/nurses/qa"
          target="_blank"
        >
          <v-icon class="mr-2">mdi-open-in-new</v-icon>
          {{ $ucfirst($t("FAQ.casenurse")) }}
        </v-btn>
      </div>
      <div class="mb-3">
        <v-btn text href="https://coroprevention.eu/trial-patients" target="_blank">
          <v-icon class="mr-2">mdi-open-in-new</v-icon>
          {{ $ucfirst($t("FAQ.patient")) }}
        </v-btn>
      </div>
    </div>
    <software-labels
      :appName="$ucfirst($t('labels.caregiverDashboard', { catalog: 'content' }))"
      instructionsUrl="https://coroprevention.eu/nurse/instructions-use-dashboard"
    />
    <div class="my-4 d-flex" :class="['justify-start']">
      <v-btn text @click="goToPreviousPage">
        <v-icon>mdi-chevron-left</v-icon>
        {{ getPreviousButtonText() }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import SoftwareLabels from '../../../shared/components/SoftwareLabels.vue';

/**
 * Component About.vue
 *
 * @module About
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/views/About.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "About",
  data: function () {
    return {
      about: null,
      loading: true,
    };
  },
  components: { SoftwareLabels },
  computed: {
    patientRecordId() {
      return this.$store.getters['followupSession/patientId'];
    }
  },
  created() {
    this.getAboutContent();
  },
  methods: {
    async getAboutContent() {
      this.$app.apolloMobileClient
        .query({
          query: gql`
            {
              documents(conditions: { field: categoryKey, value: "ABOUT" }) {
                id
                title
                parts {
                  id
                  sequence
                  type
                  ... on TextPart {
                    text
                  }
                }
              }
            }
          `,
        })
        .then((result) => {
          this.about = result.data.documents[0];
        })
        .finally(() => {
          this.loading = false;
        })
    },
    goToPreviousPage() {
      if (this.patientRecordId) {
        this.$router.push({
          name: 'PatientRecordOverview',
          params: {
            patientId: this.patientRecordId
          }
        })
      } else {
        this.$router.push({ name: 'Alerts' })
      }
    },
    getPreviousButtonText() {
      return this.$ucfirst(this.$t('buttons.backTo', {
        catalog: 'app_mobile',
        params: {
          'name': this.patientRecordId
            ? this.$t('patient.patientRecord').toLowerCase()
            : this.$t('patient.alerts').toLowerCase()
        }
      }))
    },
  },
};
</script>
